/**
 * URL utility functions
 */

/**
 * Get a query variable from the URL
 * @param {string} name - The name of the query parameter
 * @returns {string|null} The value of the query parameter or null
 */
export function getQueryVariable(name) {
  var match = RegExp("[?&]" + name + "=([^&]*)").exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

/**
 * Get all URL parameters as an object
 * @param {string} url - Optional URL string, defaults to current window location
 * @returns {Object} Object containing all URL parameters
 */
export function getAllUrlParams(url) {
  // get query string from url (optional) or window
  var queryString = url ? url.split("?")[1] : window.location.search.slice(1);

  // we'll store the parameters here
  var obj = {};

  // if query string exists
  if (queryString) {
    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split("#")[0];

    // split our query string into its component parts
    var arr = queryString.split("&");

    for (var i = 0; i < arr.length; i++) {
      // separate the keys and the values
      var a = arr[i].split("=");

      // set parameter name and value (use 'true' if empty)
      var paramName = a[0];
      var paramValue = typeof a[1] === "undefined" ? true : a[1];

      if (!typeof paramValue === "string")
        paramValue = JSON.stringify(paramValue);
      if (paramName) obj[paramName] = paramValue;
    }
  }

  return obj;
}

